import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products/ai-gateway")({
  loader: async () => {
    throw redirect({ to: "/products/$slug", params: { slug: "mcp-gateway" } });
  },
});
